<div #optComponent class="out">
  <div class="op_content">
    <div class="opt" *ngFor="let opt of options;let i = index"  kzLib (click)="selOption(i)">
      {{opt.text}}
    </div>
  </div>

</div>
